import { Action, createReducer, on } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import * as AcademicActions from './academic.actions';
import { AcademicState, initialState } from './academic.state';

const AcademicReducer = createReducer(
  initialState,
  on(AcademicActions.UpdateStateReducer, (state, value) => cloneDeep({ ...state, ...value })),
  on(AcademicActions.SelectGroupReducer, (state, { group }) => cloneDeep({ ...state, group_active: group })),
  on(AcademicActions.SelectPeriodReducer, (state, { period_id }) => cloneDeep({ ...state, period_id })),
);

export function reducer(state: AcademicState, action: Action) {
  return AcademicReducer(state, action);
}
